import {
  Component,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../shared";
import { Meta, Title } from "@angular/platform-browser";
import {
  NgbModal,
  NgbActiveModal,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { matDialogAnimations } from "@angular/material";

declare var window: MyWindow;
interface MyWindow extends Window {
  myFunction(): void;
}

@Component({
  selector: "app-modal-content-component",
  template: `
    <div class="modal-header">
      <h5 style="color: red" class="modal-title">Emergency Alert</h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.close('Close click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body table-responsive">
      <table class="table table-responsive table-condensed">
        <colgroup>
          <col width="300" />
          <col width="1000" />
        </colgroup>
        <tbody></tbody>
        <tbody>
          <tr class="text-secondary">
            <th>Country List</th>
            <th>Notice</th>
          </tr>
          <!--                                <tr class="text-secondary">
                                    <td>
                                        <p style="margin-bottom:0; font-size:9" ></p>
                                        <p style="margin-bottom:0" align="left">Planned Maintenace is in Progress</p>  

                                    </td>
                                    <td>
                                        <p style="margin-bottom:0">&nbsp;</p>
                                        <b>Dear Applicant,<br><br>
                                Please note that a planned maintenance has been scheduled today (07th February) from 4.00pm until 7.00pm (local time)
                                During this time, the ETA website (https://www.eta.org.lk/) will be unavailable.
                                Please accept our sincere apologies for any inconvenience that this may cause.<br><br>
                                Thank you,<br>
                                Department of Immigration and Emigration<br>
                                Sri Lanka<br><br><br></b>
                                    </td>
                                </tr>-->
          <!--                                <tr class="text-secondary">
                                    <td>
                                        <p style="margin-bottom:0; font-size:9" ><b>Alert 01</b> (2021.12.11 00:00)</p>
                                        <p style="margin-bottom:0" align="left">Applicable for all ETA applicants(Except Counties in Alert 3)</p>  

                                    </td>
                                    <td>
                                        <p style="margin-bottom:0">&nbsp;</p>
                                        All the travellers arriving through approved airports shall mandatorily fill the online health declaration form at <a href="https://www.airport.lk/health_declaration/index">https://www.airport.lk/health_declaration/index</a> 
                                        individually and upload the relevant documents (Vaccination record,pre-departure covid 19 negative test report , Data page of the passport etc.) prior to board to the flight. Travellers are advised to produce the QR code(In mobile / hard copy) generated from the website.
                                        <br><br><br>
                                    </td>
                                </tr>-->
          <tr class="text-secondary">
            <td>
              <p style="margin-bottom:0; font-size:9">
                <b>Alert 01</b> (2022.04.18 00:00)
              </p>
              <p style="margin-bottom:0" align="left">
                Applicable for all ETA applicants (Except Countries in Alert 02)
              </p>
            </td>
            <td>
              <p style="margin-bottom:0">&nbsp;</p>
              <b>Landing Requirements to Sri Lanka for Travellers</b
              ><br /><br />

              • As per the health guidelines issued on 18th April 2022 by the
              Director General of Health Services, fully Vaccinated travellers
              do not need to take pre-boarding and on arrival ( day 01) Covid-19
              test (PCR or Rapid Antigen test) before travelling to Sri
              Lanka.<br /><br />
              If the 'required doses' of the COVID-19 vaccination are completed
              and depart from abroad two weeks after completion of vaccination,
              they will be considered as ?Fully Vaccinated?. All travellers who
              have obtained COVID-19 vaccines should carry a proof of
              vaccination in English throughout their travel.<br /><br />

              • It is not required to submit Health Declaration Forms.<br /><br />
              Please click
              <a
                href="https://www.eta.org.lk/assets/images/SUMMARYOFARRIVALPROCEDURESAIRPORTSSEAPORTSLKA202203.pdf"
                target="_blank"
                >here</a
              >
              for further details of the quarantine procedure and Covid-19
              test<br />

              <br /><br /><br />
            </td>
          </tr>

          <!--                                <tr class="text-secondary">
                                    <td>
                                        <p style="margin-bottom:0; font-size:9" ><b>Alert 02</b> (2021.10.25 00:00)</p>
                                        <p style="margin-bottom:0" align="left">Applicable for all Tourist ETA applicants(Except Counties in Alert 3)</p>  

                                    </td>
                                    <td>
                                        <p style="margin-bottom:0">&nbsp;</p>
                                        &#8226; <b>Fully Vaccinated</b> tourists can stay at any type of accommodation and no need to be subjected to an on-arrival PCR test.<br><br>
                                        &#8226; <b>Fully Vaccinated</b> tourists can stay at any type of accommodation and no need to be subjected to an on-arrival PCR test.<br><br>
                                        &#8226; If the tourist ETA applicant is <b>not fully vaccinated</b>(Except children 12-18 years), the below-mentioned steps need to follow according to the latest (25/10/2021),Covid-19 health guidelines issued by the Health Ministry of Sri Lanka.<br><br>
                                        . For unvaccinated children below 12 years of fully vaccinated parents are allowed to travel with their parents.<br>
                                        . Unvaccinated children of 12-18 years of fully vaccinated parents need to undergo day-1 PCR testing from the approved laboratory.(If the day-1 PCR is negative they will be allowed to go with their parents as no further quarantine  needed)<br><br>
                                        <b>Step 1:</b> : Applicants who are not fully vaccinated(except children 12-18 years) are mandatorily required to reserve a safe & secure certified Level 01 hotel for quarantine purposes.<br>        
                                        Please visit <a href="https://www.srilanka.travel/helloagain">www.srilanka.travel<span>&#92;</span>helloagain<span>&#92;</span></a> for Level 01 hotel reservations and details of other compulsory requirements.<br><br>
                                        <b>Step 2</b>: Apply for Tourist ETA through the official ETA portal <a href="https://www.eta.org.lk">www.eta.org.lk</a> of the Department of Immigration & Emigration, Sri Lanka.<br><br>
                                        <b><i>Please note that Tourist ETA will only be approved upon the confirmation received from the Sri Lanka Tourism Development Authority (SLTDA) with regard to the Pre-confirmed booking of Level o1 hotel and other compulsory requirements for not fully vaccinated applicants.</b></i>
                                        <br><br>
                                        <br>
                                    </td>
                                </tr>-->

          <tr class="text-secondary">
            <td>
              <p style="margin-bottom:0; font-size:9">
                <b>Alert 02</b> (2021.01.16 00:00)
              </p>
              <p style="margin-bottom:0" align="left">
                Cameroon, Nigeria, Ivory Coast and Ghana
              </p>
            </td>
            <td>
              <p style="margin-bottom:0">&nbsp;</p>
              <!--Visitors from Cameroon, Nigeria, Ivory Coast and Ghana who intend to apply ETA may adopt one of the following channels such as approaching to nearest Sri Lanka Overseas Mission or applying through Sri Lanka sponsor for their ETA through the Head Office of the Department of Immigration & Emigration.-->
              Visitors from Cameroon, Nigeria, Ivory Coast and Ghana who intend
              to apply for ETA may apply through Sri Lankan Sponsor for their
              ETA from the Head office of the Department of Immigration &amp;
              Emigration, Sri Lanka.
            </td>
          </tr>

          <!--                                <tr class="text-secondary">
                                    <td>
                                        <p style="margin-bottom:0; font-size:9" ><b>Alert 04</b> (30.09.2021 00.00)</p>
                                        <p style="margin-bottom:0" align="left">Applicable for all ETA applicants(Except Counties in Alert 3)</p>
                                    </td>
                                    <td>
                                        <p style="margin-bottom:0">&nbsp;</p>
                                        Visitors from Cameroon, Nigeria, Ivory Coast and Ghana who intend to apply ETA may adopt one of the following channels such as approaching to nearest Sri Lanka Overseas Mission or applying through Sri Lanka sponsor for their ETA through the Head Office of the Department of Immigration & Emigration.
                                        Children up to age of 18 years do not need to do PCR tests and do not need to undergo quarantine after arriving in Sri Lanka.
                                        Travelers of 12 years and above arriving in Srilanka should mandatorily carry a negative Covid -19 test report in English language done within 72 hours prior to the embarkation.If the travelers have history of covid 19 infection during last three (03) months, instead of a PCR test, they could arrive with a negative covid 19 Rapid Antigen Test report done within 48 hours prior to embarkation.They should carry a diagnosis card or verifiable evidence or positive PCR report positive Rapid Antigen Test Report as a proof of past history of illness in English language.
                                    </td>
                                </tr>   -->
        </tbody>
      </table>
    </div>
  `,
})
export class AppModalContentComponent {
  constructor(public activeModal: NgbActiveModal) {}
}

@Component({
  selector: "home-page",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  constructor(
    private router: Router,
    private userService: UserService,
    private meta: Meta,
    private title: Title,
    private modalService: NgbModal
  ) {
    this.title.setTitle(
      "Official ETA Sri Lanka Website | Online Sri Lanka Visa | Tourist Visa"
    );
    this.meta.addTag({
      name: "description",
      content:
        "Travellers who Visit Sri Lanka are Advised to Apply for an eTA. Start Your Application Now. Get Visa to Sri Lanka in 1 hours.",
    });
    this.meta.addTag({
      name: "keywords",
      content:
        "Sri Lanka ETA, eta Sri Lanka, visa to Sri Lanka, online Sri Lanka visa, eta, tourist visa to Sri Lanka, business eta Sri Lanka, eta gov lk, official website, online eta application, short visit to Sri Lanka, evisa Sri Lanka, Sri Lanka visa online",
    });
    sessionStorage.clear();
  }

  isAuthenticated: boolean;
  closeResult: string;
  @ViewChild("infoModal") infoModalChild: TemplateRef<any>; // Note: TemplateRef

  open(content) {
    this.modalService.open(content).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  openModal() {
    this.modalService.open(this.infoModalChild);
  }

  ShowRelevant() {
    return !window.location.pathname.includes("applyvisa");
    console.log(!window.location.pathname.includes("applyvisa"));
  }

  ngOnInit() {
    sessionStorage.clear();
    this.userService.isAuthenticated.subscribe((authenticated) => {
      this.isAuthenticated = authenticated;

      // set the article list accordingly
      if (authenticated) {
      } else {
      }
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.openU();
    });
  }

  openU() {
    const modalRef = this.modalService.open(AppModalContentComponent);
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/home/home.component.ts